import { User } from "lucide-react";
import { SEXO_LABEL } from "@/lib/patient-sex";
import { CartaoDados } from "./CartaoDados";
import { LinhaEditavel } from "./LinhaEditavel";
import { calcAge, formatCpf, formatNascimento, mascara, soDigitos } from "./formatos";
import type { SecaoProps } from "./tipos";
import { useCamposDaFicha } from "./use-campos-da-ficha";

const COMO_CONHECEU = ["Indicação de paciente", "Indicação de profissional", "Google", "Instagram", "Facebook", "Convênio", "Passando em frente", "Outro"].map(
  (v) => ({ value: v, label: v }),
);

export function SecaoIdentificacao({ patient, salvar, somenteLeitura }: SecaoProps) {
  // Meia-noite UTC do Prisma → YYYY-MM-DD sem fuso, senão o Brasil mostraria o dia anterior.
  const nascimento = patient.birthDate ? new Date(patient.birthDate).toISOString().slice(0, 10) : "";
  const comum = { somenteLeitura };
  const { ver, obrigatorio } = useCamposDaFicha();
  return (
    <CartaoDados icon={User} titulo="Dados pessoais" subtitulo="Informações de identificação" tom="azul">
      <LinhaEditavel {...comum} label="Nome completo" value={patient.name ?? ""} onSave={salvar.texto("name", "Nome")} obrigatorio />
      {ver("birthDate") && (
      <LinhaEditavel
        {...comum}
        obrigatorio={obrigatorio("birthDate")}
        label="Nascimento"
        type="date"
        value={nascimento}
        formatDisplay={formatNascimento(calcAge(patient.birthDate))}
        onSave={salvar.opcao("birthDate", "Nascimento")}
      />
      )}
      {ver("sex") && (
      <LinhaEditavel
        {...comum}
        obrigatorio={obrigatorio("sex")}
        label="Sexo"
        type="select"
        value={patient.sex ?? ""}
        options={[
          { value: "F", label: "Feminino" },
          { value: "M", label: "Masculino" },
          { value: "OTHER", label: "Outro" },
        ]}
        formatDisplay={(v) => SEXO_LABEL[v] ?? ""}
        onSave={salvar.opcao("sex", "Sexo")}
      />
      )}
      {ver("document") && (
      <LinhaEditavel
        {...comum}
        obrigatorio={obrigatorio("document")}
        label="CPF"
        value={patient.document ?? ""}
        formatDisplay={formatCpf}
        maskInput={mascara(formatCpf, 11)}
        normalize={soDigitos}
        inputMode="numeric"
        placeholder="000.000.000-00"
        onSave={salvar.digitos("document", "CPF")}
      />
      )}
      {ver("profession") && (
        <LinhaEditavel {...comum} obrigatorio={obrigatorio("profession")} label="Profissão" value={patient.profession ?? ""} onSave={salvar.texto("profession", "Profissão")} />
      )}
      {ver("motherName") && (
        <LinhaEditavel {...comum} obrigatorio={obrigatorio("motherName")} label="Nome da mãe" value={patient.motherName ?? ""} onSave={salvar.texto("motherName", "Nome da mãe")} />
      )}
      {ver("howDidMeet") && (
      <LinhaEditavel
        {...comum}
        obrigatorio={obrigatorio("howDidMeet")}
        label="Como conheceu"
        type="select"
        value={patient.howDidMeet ?? ""}
        options={COMO_CONHECEU}
        onSave={salvar.opcao("howDidMeet", "Origem")}
      />
      )}
    </CartaoDados>
  );
}
